import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container, CtaBand } from "@/components/public/parts";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const data = usePublicData();
  const faqs = data?.faqs || [];
  return (
    <>
      <Seo title="FAQ | Love For Mankind" description="Answers to common questions about Love For Mankind services, referrals and transportation in Ohio." path="/faq"
        jsonLd={faqs.length ? { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })) } : null} />
      <PageHero eyebrow="Questions" title="Frequently Asked Questions" sub="Everything you need to know about getting started." breadcrumbs={[{ label: "Home", to: "/" }, { label: "FAQ" }]} />
      <Container className="py-16 lg:py-24 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border border-border rounded-xl px-5 bg-card" data-testid="faq-item">
              <AccordionTrigger className="text-left hover:no-underline font-medium text-[17px]">{f.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-[16px] leading-[1.7]">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
      <CtaBand />
    </>
  );
}
